<div class="grid">
  <div class="lg:col-6 col-12">
    <p-card>
      <div class="formgrid grid">
        <div class="field col-12">
          <label class="font-medium required-field">Название</label>
          <crm-input-text
            [(value)]="task.name"
            class="w-full"
            [isError]="$any(errors?.name)"></crm-input-text>
          <small
            *ngIf="errors?.name"
            class="p-error">
            {{ errors.name | join }}
          </small>
        </div>

        <div
          *ngIf="!canDelete"
          class="field lg:col-6 col-12">
          <label class="font-medium required-field">Тип</label>
          <crm-single-select
            [options]="types"
            [(selectedItem)]="task.type"
            [isTemplateCombined]="true"
            [filter]="false"
            dataKey="name">
            <ng-template
              #itemTemplate
              let-type="item">
              {{ type?.value | budgetRequestTypeName }}
            </ng-template>
          </crm-single-select>
          <small
            *ngIf="errors?.type"
            class="p-error">
            {{ errors.type | join }}
          </small>
        </div>

        <div class="field lg:col-6 col-12">
          <label class="font-medium">Компания</label>
          <crm-single-select
            [options]="companies"
            [(selectedItem)]="task.company"
            [virtualScroll]="true"
            [virtualScrollItemSize]="33"
            [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            [showClear]="true"
            appendTo="body"></crm-single-select>
          <small
            *ngIf="errors?.company"
            class="p-error">
            {{ errors.company | join }}
          </small>
        </div>

        <div class="field lg:col-6 col-12">
          <label class="font-medium required-field">Период</label>
          <crm-datepicker
            [(value)]="task.period"
            (valueChange)="changeDate('period', $event)"
            view="month"
            styleClass="w-full"
            [inputStyleClass]="errors?.period ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-datepicker>
          <small
            *ngIf="errors?.period"
            class="p-error">
            {{ errors.period | join }}
          </small>
        </div>

        <div
          *ngIf="task.type === BudgetRequestTypeEnum.TRANSFER_EXPENSE_BALANCES"
          class="field lg:col-6 col-12">
          <label class="font-medium required-field">Месяц остатков</label>
          <crm-datepicker
            [(value)]="task.transferDate"
            (valueChange)="changeDate('transferDate', $event)"
            view="month"
            styleClass="w-full"
            [inputStyleClass]="errors?.transferDate ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-datepicker>
          <small
            *ngIf="errors?.transferDate"
            class="p-error">
            {{ errors.transferDate | join }}
          </small>
        </div>

        <div class="field lg:col-6 col-12">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired">
            Бизнес единица
          </label>
          <crm-unit-single-select
            [(selectedUnit)]="task.unit"
            [isError]="$any(errors?.unit)"
            [showClear]="true"
            (changeValue)="loadFactAnalytics()"
            appendTo="body"></crm-unit-single-select>
          <small
            *ngIf="errors?.unit"
            class="p-error">
            {{ errors.unit | join }}
          </small>
        </div>

        <div class="field lg:col-6 col-12">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired">
            Филиал
          </label>
          <crm-filial-single-select
            [(selectedFilial)]="task.filial"
            [isError]="$any(errors?.filial)"
            [showClear]="true"
            appendTo="body"></crm-filial-single-select>
          <small
            *ngIf="errors?.filial"
            class="p-error">
            {{ errors.filial | join }}
          </small>
        </div>

        <div class="field lg:col-6 col-12">
          <label class="font-medium">Проект</label>
          <crm-single-select
            [options]="dealGroups"
            [(selectedItem)]="task.dealsGroup"
            [styleClass]="errors?.dealsGroup ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.dealsGroup ? 'ng-invalid ng-dirty' : ''"
            [showClear]="true"
            (changeValue)="loadFactAnalytics()"
            appendTo="body"></crm-single-select>
          <small
            *ngIf="errors?.dealsGroup"
            class="p-error">
            {{ errors.dealsGroup | join }}
          </small>
        </div>

        <div class="field lg:col-6 col-12">
          <label class="font-medium">Центр затрат</label>
          <crm-cost-center-single-select
            [(selectedCostCenter)]="task.costCenter"
            [isError]="$any(errors?.costCenter)"
            appendTo="body"></crm-cost-center-single-select>
          <small
            *ngIf="errors?.costCenter"
            class="p-error">
            {{ errors.costCenter | join }}
          </small>
        </div>
      </div>
    </p-card>
  </div>

  <div class="lg:col-6 col-12">
    <p-card styleClass="mb-3 very-compact-card p-3">
      <h3 class="mb-3">Задачи</h3>
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Задачи</label>
          <crm-project-multi-select
            [projects]="projects"
            [(selectedProjects)]="task.projects"
            [isError]="$any(errors?.projects)"
            appendTo="body">
          </crm-project-multi-select>
          <small
            *ngIf="errors?.projects"
            class="p-error">
            {{ errors.projects | join }}
          </small>
        </div>
      </div>
    </p-card>

    <p-card styleClass="mb-3 very-compact-card p-3">
      <h3 class="mb-3">Согласователи</h3>

      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Схема согласования</label>
          <crm-approval-scheme-single-select
            [approvalSchemas]="schemes"
            [(selectedApprovalScheme)]="task.scheme"
            (selectedApprovalSchemeChange)="changeUsersAndAuditors($event)"
            [isError]="$any(errors?.scheme)"
            [customRequest]="true"
            appendTo="body"></crm-approval-scheme-single-select>
          <small
            *ngIf="errors?.scheme"
            class="p-error">
            {{ errors.scheme | join }}
          </small>
        </div>
      </div>

      <ng-container *ngIf="task.scheme">
        <div *ngFor="let user of task.scheme.users; let index = index">
          <div class="flex align-items-center gap-1">
            <p>{{ index + 1 }}.</p>
            <crm-user-card-preview
              [user]="user"
              class="p-2"></crm-user-card-preview>
          </div>
        </div>
      </ng-container>
    </p-card>

    <p-card styleClass="very-compact-card p-3">
      <h3 class="mb-3">Аудиторы</h3>
      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
          <crm-user-multi-select
            [(selectedUsers)]="task.userAuditors"
            [isError]="$any(errors?.userAuditors)"
            [isFloatLabel]="false"
            appendTo="body"></crm-user-multi-select>
          <p
            *ngIf="errors?.userAuditors"
            class="p-error">
            {{ errors.userAuditors | join }}
          </p>
        </div>
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Группы</label>
          <crm-multi-select
            [(selectedItems)]="task.userGroupAuditors"
            [options]="userGroups"
            [class]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-multi-select>
          <p
            *ngIf="errors?.userGroupAuditors"
            class="p-error">
            {{ errors.userGroupAuditors | join }}
          </p>
        </div>
      </div>
    </p-card>
  </div>

  <!--  <div class="mt-3 col-12">-->
  <!--    <p-card styleClass="very-compact-card p-3">-->
  <!--      <div class="flex justify-content-between align-items-center flex-wrap gap-2">-->
  <!--        <div>-->
  <!--          <h3 class="required-field">Бюджетные статьи</h3>-->
  <!--        </div>-->
  <!--        &lt;!&ndash;        <div class="flex align-items-center gap-4">&ndash;&gt;-->
  <!--        &lt;!&ndash;          <p-selectButton&ndash;&gt;-->
  <!--        &lt;!&ndash;            class="select-button-widget"&ndash;&gt;-->
  <!--        &lt;!&ndash;            [options]="listOptions"&ndash;&gt;-->
  <!--        &lt;!&ndash;            [(ngModel)]="selectListFilter"&ndash;&gt;-->
  <!--        &lt;!&ndash;            (onChange)="changeFilter($event.value)">&ndash;&gt;-->
  <!--        &lt;!&ndash;            <ng-template let-item>&ndash;&gt;-->
  <!--        &lt;!&ndash;              <div&ndash;&gt;-->
  <!--        &lt;!&ndash;                [pTooltip]="item.label"&ndash;&gt;-->
  <!--        &lt;!&ndash;                tooltipPosition="top"&ndash;&gt;-->
  <!--        &lt;!&ndash;                class="select-button-tooltip"></div>&ndash;&gt;-->
  <!--        &lt;!&ndash;              <i [class]="item.icon"></i>&ndash;&gt;-->
  <!--        &lt;!&ndash;            </ng-template>&ndash;&gt;-->
  <!--        &lt;!&ndash;          </p-selectButton>&ndash;&gt;-->
  <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
  <!--      </div>-->

  <!--      <small-->
  <!--        *ngIf="errors?.items"-->
  <!--        class="p-error block">-->
  <!--        {{ errors.items | joinWithChild }}-->
  <!--      </small>-->

  <!--      <ng-container *ngIf="!directionLoading && task.items?.length">-->
  <!--        <div class="max-h-29rem overflow-y-auto overflow-x-hidden">-->
  <!--          <crm-table-->
  <!--            name="budget.task.add.directions"-->
  <!--            styleClass="mb-3 p-datatable-sm"-->
  <!--            (sortChange)="sortChange($event)"-->
  <!--            [columns]="directionColumns">-->
  <!--            <ng-template #rowTemplate>-->
  <!--              <ng-container *ngIf="(task.items | filterBudgetDirections: 'income')?.length">-->
  <!--                <tr class="surface-100">-->
  <!--                  <td [colSpan]="directionColumns?.length">-->
  <!--                    <div class="flex justify-content-between align-items-center">-->
  <!--                      <div class="text-base font-bold">Доходы</div>-->
  <!--                      <div class="font-bold">-->
  <!--                        СУММА: {{ task.items | filterBudgetDirections: 'income' | sum: 'amount' | number: '.0-0' }}-->
  <!--                      </div>-->
  <!--                    </div>-->
  <!--                  </td>-->
  <!--                </tr>-->
  <!--                <ng-container *ngFor="let item of task.items | filterBudgetDirections: 'income' | orderBy: sort">-->
  <!--                  <ng-container *ngIf="factAnalytics | findByKey: 'id':item?.direction?.id as analytics">-->
  <!--                    <ng-template-->
  <!--                      [ngTemplateOutlet]="rowDirectionTemplate"-->
  <!--                      [ngTemplateOutletContext]="{ item: item, analytics: analytics, level: 0 }"></ng-template>-->
  <!--                  </ng-container>-->
  <!--                </ng-container>-->
  <!--              </ng-container>-->

  <!--              <ng-container *ngIf="(task.items | filterBudgetDirections: 'expense')?.length">-->
  <!--                <tr class="surface-100">-->
  <!--                  <td [colSpan]="directionColumns?.length">-->
  <!--                    <div class="flex justify-content-between align-items-center">-->
  <!--                      <div class="text-base font-bold">Расходы</div>-->
  <!--                      <div class="font-bold">-->
  <!--                        СУММА: {{ task.items | filterBudgetDirections: 'expense' | sum: 'amount' | number: '.0-0' }}-->
  <!--                      </div>-->
  <!--                    </div>-->
  <!--                  </td>-->
  <!--                </tr>-->
  <!--                <ng-container *ngFor="let item of task.items | filterBudgetDirections: 'expense' | orderBy: sort">-->
  <!--                  <ng-container *ngIf="factAnalytics | findByKey: 'id':item?.direction?.id as analytics">-->
  <!--                    <ng-template-->
  <!--                      [ngTemplateOutlet]="rowDirectionTemplate"-->
  <!--                      [ngTemplateOutletContext]="{ item: item, analytics: analytics, level: 0 }"></ng-template>-->
  <!--                  </ng-container>-->
  <!--                </ng-container>-->
  <!--              </ng-container>-->
  <!--            </ng-template>-->
  <!--          </crm-table>-->
  <!--        </div>-->
  <!--      </ng-container>-->

  <!--      <crm-spinner-->
  <!--        *ngIf="directionLoading && task.items?.length"-->
  <!--        top="mt-3"></crm-spinner>-->

  <!--      <div class="flex flex-wrap align-items-center gap-3 w-full mt-3">-->
  <!--        <button-->
  <!--          *ngIf="-->
  <!--            !isShowAddDirection &&-->
  <!--            getCountDirections !== task.items?.length &&-->
  <!--            selectListFilter === ListStyleEnum.FLAT &&-->
  <!--            ((task['id'] && task.status === BudgetRequestStatusTypeEnum.DRAFT) || !task['id'])-->
  <!--          "-->
  <!--          pButton-->
  <!--          type="button"-->
  <!--          label="Добавить"-->
  <!--          icon="pi pi-plus"-->
  <!--          class="p-button-outlined p-button-success"-->
  <!--          (click)="toggleAddDirection()"></button>-->

  <!--        <ng-container *ngIf="factAnalytics?.length && task.items?.length">-->
  <!--          <button-->
  <!--            *ngIf="selectedDirection?.length"-->
  <!--            pButton-->
  <!--            type="button"-->
  <!--            label="Заполнить по макс."-->
  <!--            class="p-button-outlined"-->
  <!--            (click)="fillDirectionAmount(factAnalytics, 'max')"></button>-->

  <!--          <button-->
  <!--            *ngIf="selectedDirection?.length"-->
  <!--            pButton-->
  <!--            type="button"-->
  <!--            label="Заполнить по пред."-->
  <!--            class="p-button-outlined"-->
  <!--            (click)="fillDirectionAmount(factAnalytics, 'previous')"></button>-->

  <!--          <button-->
  <!--            *ngIf="selectedDirection?.length"-->
  <!--            pButton-->
  <!--            type="button"-->
  <!--            label="Заполнить по сред."-->
  <!--            class="p-button-outlined"-->
  <!--            (click)="fillDirectionAmount(factAnalytics, 'average')"></button>-->
  <!--        </ng-container>-->

  <!--        <button-->
  <!--          *ngIf="!isShowAddDirection && getCountDirections !== task.items?.length"-->
  <!--          pButton-->
  <!--          label="Заполнить все"-->
  <!--          class="p-button-text p-button-info"-->
  <!--          (click)="setAllDirections()"></button>-->

  <!--        <button-->
  <!--          *ngIf="task.items?.length"-->
  <!--          pButton-->
  <!--          [label]="isSelectAllDirections ? 'Убрать все' : 'Выбрать все'"-->
  <!--          class="p-button-text p-button-info"-->
  <!--          (click)="selectAllDirections()"></button>-->
  <!--      </div>-->

  <!--      <div-->
  <!--        *ngIf="isShowAddDirection"-->
  <!--        class="flex align-items-center gap-3 w-full mt-3">-->
  <!--        <crm-direction-multi-select-->
  <!--          [directions]="directions"-->
  <!--          [(selectedDirections)]="selectedDirections"-->
  <!--          (selectedDirectionsChange)="addDirections()"-->
  <!--          class="flex-grow-1 max-w-95"-->
  <!--          appendTo="body"></crm-direction-multi-select>-->

  <!--        <i-->
  <!--          class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"-->
  <!--          style="font-size: 1.3rem"-->
  <!--          (click)="isShowAddDirection = false"></i>-->
  <!--      </div>-->
  <!--    </p-card>-->
  <!--  </div>-->
</div>

<div class="grid mt-3">
  <div class="col-12 flex flex-wrap justify-content-between">
    <div>
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="onSave(task)"></button>
      <crm-go-back-button
        *ngIf="!isModal"
        [route]="route"></crm-go-back-button>
    </div>
    <button
      *ngIf="canDelete"
      pButton
      label="Удалить"
      class="p-button-danger p-button-text"
      (click)="delete.emit(task)"></button>
  </div>
</div>

<ng-template
  #rowDirectionTemplate
  let-item="item"
  let-level="level"
  let-analytics="analytics">
  <tr *ngIf="toItem(item) as item">
    <td>
      <div
        [style]="
          'padding-left: ' +
          ((item.children?.length ? 0 : selectListFilter === ListStyleEnum.FLAT ? 0 : 30) + level * 14) +
          'px;'
        "
        class="flex align-items-center gap-3">
        <p-checkbox
          [ngModel]="!!(selectedDirection | keyValueFind: { 'direction.id': item?.direction?.id })"
          (ngModelChange)="selectDirection(item)"
          [binary]="true"></p-checkbox>

        <crm-toggler-icon-table
          *ngIf="item.children?.length"
          [isShow]="openedDirectionIds[item.direction?.id]"
          (isShowChange)="toggleDirection(item.direction?.id)"></crm-toggler-icon-table>
        <p>{{ item.direction?.name }}</p>
      </div>
    </td>
    <td>
      <p-inputNumber
        *ngIf="
          !item.children?.length && ((task['id'] && task.status === BudgetRequestStatusTypeEnum.DRAFT) || !task['id']);
          else notEditAmount
        "
        [(ngModel)]="item.amount"
        (ngModelChange)="changeAmount(item, $event)"
        class="w-13rem"
        inputStyleClass="w-13rem"
        styleClass="w-13rem"></p-inputNumber>

      <ng-template #notEditAmount>
        <p>{{ item.amount | number: '.0-0' }}</p>
      </ng-template>
    </td>
    <ng-container *ngIf="directionMonths?.length && toAnalytics(analytics) as analytics">
      <ng-container *ngFor="let key of directionMonths">
        <td>
          {{ analytics.monthAmount[key] | number: '.0-0' }}
        </td>
      </ng-container>
    </ng-container>
  </tr>

  <ng-container *ngIf="item.children?.length && openedDirectionIds[item.direction?.id]">
    <ng-template
      *ngFor="let child of item.children | orderBy: sort"
      [ngTemplateOutlet]="rowDirectionTemplate"
      [ngTemplateOutletContext]="{ item: child, level: level + 1 }"></ng-template>
  </ng-container>
</ng-template>
